import React from 'react'
import { connect } from 'react-redux'

import UnprocessedRecords from './UnprocessedRecords'
import { fetchUnprocessedRecordsList } from './actions'


class UnprocessedRecordsList extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.dispatch(fetchUnprocessedRecordsList);
    }

    render() {
        return (
            <UnprocessedRecords unprocessedRecordsList={this.props.unprocessed_records} />
        );
    }
}

const mapStateToProps = state => ({
    unprocessed_records: state.unprocessed_records
});

export default connect(mapStateToProps)(UnprocessedRecordsList)
